'use client';

import React from 'react';
import { useSearchParams } from 'next/navigation';
import Link from 'next/link';
import { SidebarMenuButton, SidebarMenuItem, SidebarMenuSub, Skeleton } from '@design-system';
import { Path } from '@apply/server-actions/results/current-applicant.result';
import { useClientTranslations } from '@core-systems/i18n';
import { useCurrentApplicant } from '@apply/hooks/applicant/queries/use-current-applicant';
function PathLink({ locale, path }: { path: Path; locale: string }): React.JSX.Element {
  const { t } = useClientTranslations('apply');
  const searchParams = useSearchParams();
  const paramsPathId = searchParams.get('pathId');
  const href = `/${locale}/paths?pathId=${path.id}`;
  return (
    <SidebarMenuItem>
      <SidebarMenuButton asChild isActive={paramsPathId === path.id}>
        <Link href={href}>
          {path.campus.name} - {t(`path.types.${path.pathType}`)}
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
}

export function PathLinks(): React.JSX.Element {
  const { locale } = useClientTranslations();
  const { applicant, isLoading, error } = useCurrentApplicant();

  if (isLoading) {
    return (
      <SidebarMenuSub>
        <SidebarMenuItem>
          <SidebarMenuButton isActive>
            <Skeleton className="h-[1em] w-full" />
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenuSub>
    );
  }

  if (error || !applicant) {
    return <></>;
  }

  return (
    <SidebarMenuSub>
      {applicant.activePaths.map((path) => (
        <PathLink locale={locale} path={path} key={path.id} />
      ))}
    </SidebarMenuSub>
  );
}
